import { useMutation } from '@tanstack/vue-query'
import type { SuccessResponse } from '~/types/response'

const useForgotPassword = () => {
  const { fetch } = useAPIFetch()

  return useMutation({
    mutationFn: ({ email }: { email: string }) =>
      fetch<SuccessResponse<any>>({
        method: 'POST',
        url: 'users/forgot-password',
        data: {
          email,
        },
      }),
  })
}

export default useForgotPassword
